import { render, staticRenderFns } from "./professor-turma.vue?vue&type=template&id=317f0b54&"
import script from "./professor-turma.vue?vue&type=script&lang=js&"
export * from "./professor-turma.vue?vue&type=script&lang=js&"
import style0 from "./professor-turma.vue?vue&type=style&index=0&id=317f0b54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports